import React, { useEffect, useState } from 'react';
import Pagination from '../../components/Pagination';
import InnerLayout from '../../components/layouts/innerLayout';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import search from "../../assets/icons/searchIcon.svg";
import { errorToast } from '../../components/toast';
import { exportReportAction, transactionsListAction } from '../../redux/actions/billingAction';
import { formatDate, formatString } from '../../components/helper';
import LoaderModal from '../../components/modals/loaderModal';
import ExportModal from '../../components/modals/exportModal';
import exportFromJSON from "export-from-json";

const Transactions = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState("");
    const [paginationData, setPaginationData] = useState(null);
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isModalOpen, setModalOpen] = useState(false);
    const fileName = "transactionReport"; // CSV
    const exportType = exportFromJSON.types.csv; // CSV

    const itemsPerPage = 15;
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= paginationData?.totalPages) {
            setCurrentPage(newPage);
        }
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(searchValue);
            setCurrentPage(1)
        }, 300);

        return () => {
            clearTimeout(handler);
        };
    }, [searchValue]);

    useEffect(() => {
        fetchProducts()
    }, [currentPage, debouncedValue])

    const fetchProducts = () => {
        setLoading(true)
        dispatch(transactionsListAction({ page: currentPage, search: debouncedValue, page_size: itemsPerPage, fromDate, toDate }, onSuccess, onError))
    }

    const onSuccess = (data) => {
        setInvoices(data.data.data.transactions);
        setPaginationData(data.data.data.pagination)
        setLoading(false)
    }

    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
        setLoading(false)
    }

    const handleFilter = () => {
        fetchProducts();
    };

    const handleClearFilter = () => {
        setFromDate('');
        setToDate('');
        setLoading(true)
        dispatch(transactionsListAction({ page: currentPage, search: debouncedValue, page_size: itemsPerPage, }, onSuccess, onError))
    };


    const handleExport = (fromDate, toDate) => {
        console.log('Exporting report from:', fromDate, 'to:', toDate);
        setLoading(true)
        dispatch(exportReportAction({ fromDate, toDate }, onExportSuccess, onError))

    };

    const onExportSuccess = (data) => {
        exportFromJSON({ data: data.data.data, fileName, exportType });
        setLoading(false)
        setModalOpen(false);

    }

    return (
        <InnerLayout module={"Transactions"} is_new={true} navigationPath={"/pos/billing"}>
            <div className="w-full flex flex-col h-full p-4">
                <div className="w-full sm:w-auto mb-2 flex flex-wrap md:flex-nowrap gap-2">
                    <div
                        style={{ height: "2.5rem" }}
                        className={`input_border flex items-center rounded-md w-full sm:w-auto mx-1 md:w-1/3`}
                    >
                        <span className="px-2">
                            <img width={"16px"} src={search} alt="search icon" />
                        </span>
                        <input
                            placeholder={`Search here`}
                            className="table_search_input w-full rounded-md placeholder:text-sm py-1 px-2"
                            type="text"
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e?.target?.value);
                            }}
                        />
                        <span className='fs_14 mx-3 cursor-pointer text-primary' onClick={() => setSearchValue('')} >Clear</span>
                    </div>
                    <div className='w-full flex flex-wrap items-center md:justify-end px-2 gap-2'>
                        <div>
                            <label className='px-2'>From</label>
                            <input
                                type="date"
                                className="input_border py-1 px-2 rounded-md"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                placeholder="From Date"
                            />
                        </div>
                        <div>
                            <label className='px-2'>To</label>
                            <input
                                type="date"
                                className="input_border py-1 px-2 rounded-md"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                placeholder="To Date"
                            />
                        </div>
                        <button
                            className={`py-2 px-4 rounded-md text-white ${fromDate || toDate ? "bg-primary" : "bg-gray-300 cursor-not-allowed"}`}
                            disabled={!fromDate && !toDate}
                            onClick={handleFilter}
                        >
                            Apply Filter
                        </button>
                        <button
                            className={`py-2 px-4 rounded-md text-white ${fromDate || toDate ? "bg-primary" : "bg-gray-300 cursor-not-allowed"}`}
                            disabled={!fromDate && !toDate}
                            onClick={handleClearFilter}
                        >
                            Clear
                        </button>
                        <button
                            className={`py-2 px-4 rounded-md text-white bg-primary`}
                            onClick={() => setModalOpen(true)}
                        >
                            Export
                        </button>
                    </div>
                </div>
                <div className="bg-white shadow-lg rounded-lg overflow-auto flex-1">
                    <table className="min-w-full table-auto">
                        <thead className="bg-slate-300 sticky top-0">
                            <tr>
                                <th className="px-4 py-2">#</th>
                                <th className="px-4 py-2">Invoice No</th>
                                <th className="px-4 py-2">Mobile</th>
                                <th className="px-4 py-2">Customer Name</th>
                                <th className="px-4 py-2">Payment method</th>
                                <th className="px-4 py-2">Total Amount</th>
                                <th className="px-4 py-2">Billed Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.length > 0 ? invoices.map((invoice, index) => (
                                <tr key={invoice?.id} className="border-b hover:bg-primary-light cursor-pointer" onClick={() => navigate('/invoice', { state: { invoiceData: invoice } })}>
                                    <td className="py-2 ">{(currentPage - 1) * paginationData?.pageSize + (index + 1)}</td>
                                    <td className="py-2">{invoice?.code}</td>
                                    <td className="py-2">{invoice?.customerPhone ? invoice?.customerPhone : "--"}</td>
                                    <td className="py-2">{invoice?.customerName ? invoice?.customerName : "--"}</td>
                                    <td className="py-2">{formatString(invoice?.payment_method)}</td>
                                    <td className="py-2">{invoice?.grandTotal}</td>
                                    <td className="py-2">{formatDate(invoice?.createdAt)}</td>
                                </tr>
                            )) :
                                <tr style={{ height: '30rem' }}>
                                    <td colSpan="9" className="py-4 text-center">
                                        No invoices found
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                {/* Pagination Footer */}
                <div className="bg-white p-4 mt-4 shadow-2xl">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={paginationData?.totalPages}
                        onPageChange={handlePageChange}
                    />
                </div>
                {loading &&
                    <LoaderModal />
                }
                <ExportModal
                    isOpen={isModalOpen}
                    onClose={() => setModalOpen(false)}
                    onExport={handleExport}
                />
            </div>
        </InnerLayout>
    );
};

export default Transactions;
